module.exports = __webpack_public_path__ + "static/media/preloader.118a2eaf.gif";